export default {
  summary: [],
  loadingDocuments:{},
  sharingDocuments:{},
  typingDocuments:{},
  currentDocument:[],
  reminderDocuments:[]
};
